import { delay } from "common/promises";
export async function run({ pixiContext, elements: { black, background, shade, title, button, heart }, }) {
    black.sprite.visible = true;
    background.sprite.visible = true;
    heart.sprite.visible = true;
    shade.sprite.visible = true;
    heart.play();
    await pixiContext.fadeOut({
        durationMS: 1000,
        sprite: black.sprite,
    });
    title.sprite.alpha = 0;
    title.sprite.visible = true;
    title.sprite.play();
    await pixiContext.fadeIn({ durationMS: 1000, sprite: title.sprite });
    await delay(333);
    await pixiContext.fadeOut({ durationMS: 1000, sprite: shade.sprite });
    await pixiContext.fadeOut({ durationMS: 160, sprite: title.sprite });
    await delay(333);
    button.sprite.alpha = 0;
    button.sprite.visible = true;
    await pixiContext.fadeIn({ durationMS: 333, sprite: button.sprite });
}
//# sourceMappingURL=loadingAnimation.js.map